const LISTED_SPECIES = [
  'mothplant',
  'oldmansbeard',
  'cathedralbells',
  'bananapassionfruit',
  'bluepassionflower',
  'pinkjasmine',
  'jasmine',
  'japanesehoneysuckle',
  'bluemorningglory',
  'woollynightshade',
  'elaeagnus',
]

function displaySpeciesName(value) {
  if (value == null) return ''
  let s = String(value).trim()
  const paren = s.indexOf('(')
  if (paren >= 0) s = s.slice(0, paren).trim()
  return s
}

function normalizeSpeciesName(value) {
  return displaySpeciesName(value)
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/\s+/g, '')
}

function isListedSpecies(speciesName) {
  return LISTED_SPECIES.includes(normalizeSpeciesName(speciesName))
}

function coerceDate(value) {
  if (value == null || value === '') return null
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date
}

function octoberFirst(year) {
  return new Date(year, 9, 1)
}

function startOfNextDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
}

function maxNextVisitDate(today = new Date()) {
  const now = coerceDate(today)
  if (!now) return null
  return new Date(now.getFullYear() + 5, now.getMonth(), now.getDate())
}

/**
 * Suggested next-visit date for a listed species, or null when none applies.
 * colour is yellow, orange, green, pink, or red.
 * The result is 1 October in the local timezone, after today, and no later
 * than five years after today. Returns null when that date would be later.
 */
function suggestNextVisitDate(visitDate, colour, speciesName, today = new Date()) {
  if (!isListedSpecies(speciesName)) return null
  if (colour !== 'yellow' && colour !== 'orange' && colour !== 'green' && colour !== 'pink') {
    return null
  }

  const visit = coerceDate(visitDate)
  const now = coerceDate(today)
  if (!visit || !now) return null

  const year = visit.getFullYear()
  const month = visit.getMonth() + 1

  let suggestedYear
  if (colour === 'yellow' || colour === 'orange') {
    suggestedYear = month < 8 ? year : year + 1
  } else {
    suggestedYear = month < 10 ? year + 1 : year + 2
  }

  let suggested = octoberFirst(suggestedYear)
  const earliest = startOfNextDay(now)
  const latest = maxNextVisitDate(now)
  while (suggested < earliest) {
    suggested = octoberFirst(suggested.getFullYear() + 1)
  }
  if (suggested > latest) return null
  return suggested
}

module.exports = {
  suggestNextVisitDate,
  maxNextVisitDate,
  isListedSpecies,
  normalizeSpeciesName,
}
